import React from "react"
import { storyblokEditable } from "@storyblok/react"

import { useStaticQuery, graphql } from "gatsby"
import { getImage } from "gatsby-plugin-image"

import { FullwidthBanner, transformLinkUri } from "gatsby-theme-gba"

const FullwidthBannerEditable = ({ blok }) => {
  const { file } = useStaticQuery(graphql`
    query fullwidthBannerExampleQuery {
      file(relativePath: { eq: "slide-image.jpg" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  `)

  let desktopImageFile = blok.desktopImage
  let mobileImageFile = blok.mobileImage

  return (
    <div {...storyblokEditable(blok)} key={blok._uid}>
      <FullwidthBanner
        desktopImage={desktopImageFile || getImage(file)}
        mobileImage={mobileImageFile || getImage(file)}
        imageAlt={blok.imageAlt}
      />
    </div>
  )
}

export default FullwidthBannerEditable
